import { FileIdSchema, NameSchema } from '@mntn-dev/domain-types'
import type { ZodSimplify } from '@mntn-dev/utility-types'
import { z } from 'zod'

export const StructuredMetadataSchema = z.object({
  file_name: NameSchema,
  external_id: FileIdSchema,
})
export type StructuredMetadata = ZodSimplify<typeof StructuredMetadataSchema>
